import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiDollarSign,
  FiPackage,
  FiRotateCcw,
  FiCreditCard
} from 'react-icons/fi';
import './ReportesMenu.scss';

const ReportesMenu = () => {
  const navigate = useNavigate();

  const reportes = [
    {
      id: 'ventas',
      label: 'REPORTE\nDE VENTAS',
      icon: FiDollarSign,
      gradient: 'blue-dark-gradient',
      route: '/system/reportes/ventas'
    },
    {
      id: 'inventario',
      label: 'REPORTE\nDE INVENTARIO',
      icon: FiPackage,
      gradient: 'blue-dark-gradient',
      route: '/system/reportes/inventario'
    },
    {
      id: 'retornos',
      label: 'REPORTE\nDE RETORNOS',
      icon: FiRotateCcw,
      gradient: 'blue-dark-gradient',
      route: '/system/reportes/retornos'
    },
    {
      id: 'creditos',
      label: 'REPORTE\nDE CRÉDITOS',
      icon: FiCreditCard,
      gradient: 'blue-dark-gradient',
      route: '/system/reportes/creditos'
    }
  ];

  const handleCardClick = (reporte) => {
    navigate(reporte.route);
  };

  return (
    <div className="reportes-menu-page">
      <div className="reportes-menu-container">
        <h1 className="reportes-menu-title">
          REPORTES<br/>Y ANÁLISIS
        </h1>

        <div className="reportes-menu-grid">
          {reportes.map((reporte) => (
            <div
              key={reporte.id}
              className={`reporte-card ${reporte.gradient}`}
              onClick={() => handleCardClick(reporte)}
            >
              <div className="reporte-card-icon">
                <reporte.icon size={40} />
              </div>
              <h2 className="reporte-card-title">
                {reporte.label.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < reporte.label.split('\n').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportesMenu;
